import { render, staticRenderFns } from "./PlacePartForm.vue?vue&type=template&id=9827f2e4&"
import script from "./PlacePartForm.vue?vue&type=script&lang=js&"
export * from "./PlacePartForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports